import { z } from 'zod';
export const DateModel = z.object({
    day: z.number(),
    month: z.number(),
    year: z.number(),
});
